import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useNavState } from '@/common/navState/NavStateContext';
import { StringUtils } from '@/common/utils/StringUtils';
import { ValList } from '@/common/val/ValList';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';

export const AbvClosureDetail = () => {
  const module = useModuleFromRoute();

  const { entityObj } = useEntityMgr();
  const { navigateTo } = useNavState();

  const valCodeContextMenuItems = (row) => {
    let contextMenuItems = [];

    const code = row.code;

    // Manual Accrual Navigation
    if (
      [
        'SAP_ACTUAL_PIPELINE_DISCREPANCY',
        'SAP_ACTUAL_ACCRUAL_DISCREPANCY',
        'MAN_ACCR_ADJ_MISSING_QTR',
        'MAN_ACCR_ADJ_MISSING_ENTRY_TYPE',
      ].includes(code)
    ) {
      let navState = {
        pluginCode: 'MAN_ACCR_ADJ_VAL_DATA_PLUGIN',
        reqParam: { periodId: entityObj.periodId },
      };
      contextMenuItems.push({
        name: 'Open Manual Accrual Adjustments',
        icon: fas.faBook,
        action: () => navigateToEntity('MAN_ACCR_ADJ', navState),
      });
    }

    let navState = {
      mode: Mode.PERSPECTIVE,
      perspectiveState: {
        dimFilters: { PAID_PERIOD: [entityObj.periodId] },
      },
    };

    // Reserve Navigation
    if (
      [
        'SAP_ACTUAL_PIPELINE_DISCREPANCY',
        'SAP_ACTUAL_ACCRUAL_DISCREPANCY',
        'SAP_RECON_PAYMENT_DISCREPANCY',
        'UNCATEGORIZED_PROD',
        'DSA_BAL_MISSING',
        'BAD_DEBT_BAL_MISSING',
        'SAP_ACTUAL_BALANCE_DISCREPANCY',
        'MCD_PYMT_DISCREPANCY',
      ].includes(code)
    ) {
      contextMenuItems.push({
        name: 'Open Reserve',
        icon: fas.faClipboard,
        action: () => navigateToEntity('RESERVE', navState),
      });
    }

    // SAP Reconciliation Navigation
    if (
      [
        'SAP_ACTUAL_PYMT_DISCREPANCY',
        'SAP_RECON_PAYMENT_DISCREPANCY',
        'HAS_DISCREPANCY',
        'CHBK_PYMT_DISCREPANCY',
      ].includes(code)
    ) {
      contextMenuItems.push({
        name: 'Open SAP Reconciliation',
        icon: fas.faBalanceScale,
        action: () => navigateToEntity('SAP_RECON', navState),
      });
    }

    // SAP Actuals Navigation
    if (
      [
        'SAP_ACTUAL_PYMT_DISCREPANCY',
        'SAP_ACTUAL_PIPELINE_DISCREPANCY',
        'SAP_ACTUAL_ACCRUAL_DISCREPANCY',
        'SAP_ACTUAL_BALANCE_DISCREPANCY',
      ].includes(code)
    ) {
      contextMenuItems.push({
        name: 'Open SAP Actuals',
        icon: fas.faBook,
        action: () => navigateToEntity('SAP_ACTUALS', navState),
      });
    }

    // Medicaid Payments Navigation
    if (['MCD_PYMT_DISCREPANCY'].includes(code)) {
      contextMenuItems.push({
        name: 'Open Medicaid Payments',
        icon: fas.faLandmarkAlt,
        action: () => navigateToEntity('MCD_PYMT_ACTUALS', navState),
      });
    }

    // Chargeback Payment Navigation
    if (['CHBK_PYMT_DISCREPANCY'].includes(code)) {
      contextMenuItems.push({
        name: 'Open Chargeback Payments',
        icon: fas.faCalculator,
        action: () => navigateToEntity('CHBK_PYMT', navState),
      });
    }

    return contextMenuItems;
  };

  const navigateToEntity = (entity, navState) => {
    navigateTo(`${module}/${StringUtils.toKebabConvention(entity)}`, navState);
  };

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    {
      id: 'valTab',
      label: 'Validations',
      content: (
        <ValList
          parentEntity="CLOSURE"
          parentEntityId={entityObj.id}
          valCodeContextMenuItems={valCodeContextMenuItems}
        />
      ),
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
